"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./SpecialImageCaption.css");
var _SpecialPriceVariation = _interopRequireDefault(require("../Special/components/SpecialPriceVariation"));
var SpecialImageCaption = function SpecialImageCaption(props) {
  var image = props.image,
    name = props.name,
    description = props.description,
    variations = props.variations,
    category = props.category;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "special-image-caption-container"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: name,
    className: "special-image-caption"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "special-image-caption-text-block"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "special-image-caption-caption"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "special-image-caption-title"
  }, name), category && /*#__PURE__*/_react["default"].createElement("h4", {
    className: "special-image-caption-title-category"
  }, category), /*#__PURE__*/_react["default"].createElement("span", {
    className: "special-image-caption-description"
  }, description), /*#__PURE__*/_react["default"].createElement(_SpecialPriceVariation["default"], {
    variations: variations
  }))));
};
SpecialImageCaption.propTypes = {
  image: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  variations: _propTypes["default"].array.isRequired,
  description: _propTypes["default"].string.isRequired
};
var _default = SpecialImageCaption;
exports["default"] = _default;